import { getAbsoluteUrl } from "./services/index.js";
const buildUrl = (videoUrl) => {
  const url = new URL("https://www.wixapis.com/ricos/v1/oembeds");
  url.searchParams.append("url", getAbsoluteUrl(videoUrl));
  url.searchParams.append("options.maxWidth", "980");
  return url;
};
const fetchOembed = async (url, instance) => {
  const res = await fetch(buildUrl(url), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: instance
    }
  });
  return res.json();
};
const fetchVideoOembed = async (url, makeRequest) => {
  const res = await makeRequest(buildUrl(url), {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  });
  return res.json();
};
const providerBlackList = ["wix", "facebook"];
const fetchEmbedData = (instance) => async (url) => {
  try {
    return fetchOembed(url, instance).then((json) => {
      const { html, ...rest } = json;
      const { provider_name } = rest;
      const res = providerBlackList.includes((provider_name || "").toLowerCase()) ? { ...rest } : { ...rest, html };
      return res;
    });
  } catch {
    return new Promise((resolve) => {
      setTimeout(() => resolve({}), 1);
    });
  }
};
export {
  fetchEmbedData,
  fetchOembed,
  fetchVideoOembed
};
//# sourceMappingURL=fetchEmbedData.js.map
